import { Facebook, Instagram, MapPin, Phone } from "lucide-react";
import { useLenis } from "lenis/react";

export default function Footer() {
  const lenis = useLenis();
  return (
    <footer data-testid="site-footer" className="bg-ink border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6">
        <button
          data-testid="footer-logo"
          onClick={() => lenis?.scrollTo(0, { duration: 1.6 })}
          className="group"
        >
          <img
            src="/assets/logo.png"
            alt="Pizzeria Grano Fiumefreddo"
            className="w-36 sm:w-44 rounded-full group-hover:scale-[1.04] transition-transform duration-500"
          />
        </button>
        <p className="text-cream/40 text-xs tracking-[0.3em] uppercase mt-2">
          Pizzeria Artigianale · Fiumefreddo di Sicilia
        </p>

        <div className="grid sm:grid-cols-3 gap-10 mt-16 border-t border-white/10 pt-12">
          <div>
            <h4 className="text-[11px] tracking-[0.35em] uppercase text-terra">Dove</h4>
            <p className="text-cream/55 text-sm mt-4 leading-relaxed flex items-start gap-2">
              <MapPin size={14} className="shrink-0 mt-1 text-cream/40" />
              Via Guglielmo Marconi, 48<br />
              95013 Fiumefreddo di Sicilia (CT)
            </p>
          </div>
          <div>
            <h4 className="text-[11px] tracking-[0.35em] uppercase text-terra">Quando</h4>
            <p className="text-cream/55 text-sm mt-4 leading-relaxed">
              Aperti 7 giorni su 7<br />
              Servizio serale dalle 19:00
            </p>
          </div>
          <div>
            <h4 className="text-[11px] tracking-[0.35em] uppercase text-terra">Seguici</h4>
            <div className="flex items-center gap-4 mt-4">
              <a
                data-testid="footer-facebook"
                href="https://www.facebook.com/share/1DQ1vZMqLk/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-white/15 p-3 text-cream/60 hover:text-gold hover:border-gold/50 transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={17} strokeWidth={1.5} />
              </a>
              <a
                data-testid="footer-instagram"
                href="https://www.instagram.com/pizzeriagranofiumefreddo"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-white/15 p-3 text-cream/60 hover:text-gold hover:border-gold/50 transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={17} strokeWidth={1.5} />
              </a>
              <a
                data-testid="footer-phone"
                href="tel:+393892472195"
                className="border border-white/15 p-3 text-cream/60 hover:text-gold hover:border-gold/50 transition-colors duration-300"
                aria-label="Telefono"
              >
                <Phone size={17} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-4 border-t border-white/10 mt-12 pt-8 text-cream/30 text-xs tracking-[0.15em] uppercase">
          <span>© 2026 Pizzeria Grano · Fiumefreddo di Sicilia</span>
          <span>Lievitazione 24/48h · Farine Siciliane</span>
        </div>
      </div>
    </footer>
  );
}
